import { AbstractControl, FormBuilder, FormGroup } from '@angular/forms';

export class FormGroupHelper {
  static createFilterFormGroup(formBuilder: FormBuilder, keys: string[]): FormGroup {
    const group: { [key: string]: any } = {};
    keys.forEach(key => {
      group[key] = [null];
    });
    return formBuilder.group(group);
  }

  static getControlName(c: AbstractControl): string | null {
    return (
      Object.keys(c.parent!.controls).find(
        (name) => c === c.parent!.get(name)
      ) || null
    );
  }
}
